import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "PAK School & College System - Excellence in Education",
  description = "PAK School & College System offers quality education with modern facilities, experienced teachers, and comprehensive academic programs. Join us for a bright future.",
  keywords = "PAK School, College, Education, Pakistan, Academic Excellence, Student Development, Quality Education",
  image = "/assets/hero-banner.jpg",
  url = "",
  type = "website",
  structuredData = null,
  canonical = "",
  noindex = false,
  nofollow = false
}) => {
  const baseUrl = "https://pakschoolandcollege.com";
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
  const fullImageUrl = image.startsWith('http') ? image : `${baseUrl}${image}`;
  const canonicalUrl = canonical ? `${baseUrl}${canonical}` : fullUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="PAK School & College System" />
      <meta name="robots" content={`${noindex ? 'noindex' : 'index'}, ${nofollow ? 'nofollow' : 'follow'}`} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Google Site Verification */}
      <meta name="google-site-verification" content="1S7aQ_f0tJMAX3KWArNehedQ_ecEvoAnH6mjGnvSh1o" />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="PAK School & College System" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:site" content="@pakschoolcollege" />
      <meta name="twitter:creator" content="@pakschoolcollege" />
      
      {/* Additional SEO Meta Tags */}
      <meta name="theme-color" content="#1e40af" />
      <meta name="msapplication-TileColor" content="#1e40af" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="PAK School & College" />
      
      {/* Language and Geo Tags */}
      <meta name="language" content="English" />
      <meta name="geo.region" content="PK" />
      <meta name="geo.country" content="Pakistan" />
      
      {/* Structured Data */}
      {structuredData && (
        Array.isArray(structuredData) ? 
          structuredData.map((data, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(data)}
            </script>
          )) :
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
      )}
    </Helmet>
  );
};

export default SEO;
